import * as flowDesignerActions from 'actions/flowDesigner';
import * as flowDesignerDebuggerActions from 'actions/flowDesignerDebugger';
import {
  ACTIVITY_PANEL_DEFAULT_DATE,
  ACTIVITY_PANEL_DEFAULT_FILTERS,
} from 'xm-constants/activityPanel';
import { ProcessStatus } from '@xmatters/common/constants/commonStatus';
import difference from 'lodash/difference';

const {
  OPEN_FLOW_DEBUGGER,
  CLOSE_FLOW_DEBUGGER,

  CLEAR_SELECTED_LOG,

  SET_DEBUGGER_LOG_START,
  SET_DEBUGGER_LOG_FAIL,
  SET_DEBUGGER_LOG_SUCCESS,

  SET_STEP_RESULTS_START,
  SET_STEP_RESULTS_FAIL,
  SET_STEP_RESULTS_SUCCESS,

  SET_FLOW_ACTIVITY_FILTERS,

  SET_DATE_TYPE_FILTER,
  FLOW_ACTIVITY_SET_SELECTED_REQUEST,
  FLOW_ACTIVITY_SET_SELECTED_STEP_ID,
} = flowDesignerDebuggerActions;

const getFilterDefaults = defaultFilters => ({
  ...ACTIVITY_PANEL_DEFAULT_FILTERS,
  ...(defaultFilters || {}),
});

const getDefaultState = () => ({
  filters: getFilterDefaults(),
  isOpen: false,
  selectedLog: null,
  selectedLogError: null,
  selectedStepResult: null,
  selectedDateTypeFilter: ACTIVITY_PANEL_DEFAULT_DATE,
  selectedRequest: null,
  selectedStepId: null,
});

export default function flowDesignerDebugger(
  state = getDefaultState(),
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case OPEN_FLOW_DEBUGGER: {
      return {
        ...state,
        isOpen: true,
        filters: getFilterDefaults(payload?.filters),
      };
    }
    case flowDesignerActions.FLOW_DESIGNER_LEAVE_WORKFLOW:
    case flowDesignerActions.FLOW_DESIGNER_CLOSE:
    case CLOSE_FLOW_DEBUGGER: {
      return getDefaultState();
    }
    case CLEAR_SELECTED_LOG: {
      return {
        ...state,
        selectedLog: null,
        selectedLogError: null,
      };
    }
    case SET_DEBUGGER_LOG_START: {
      return {
        ...state,
        selectedLogError: null,
        selectedLogStatus: ProcessStatus.LOADING,
      };
    }
    case SET_DEBUGGER_LOG_FAIL: {
      return {
        ...state,
        selectedLogError: payload,
        selectedLogStatus: ProcessStatus.ERROR,
      };
    }
    case SET_DEBUGGER_LOG_SUCCESS: {
      return {
        ...state,
        selectedLog: payload,
        selectedLogError: null,
        selectedLogStatus: ProcessStatus.SUCCESS,
      };
    }
    case SET_STEP_RESULTS_START: {
      return {
        ...state,
        stepResultsError: false,
        stepResultsLoading: true,
        selectedStepResult: null,
      };
    }
    case SET_STEP_RESULTS_FAIL: {
      return {
        ...state,
        stepResultsError: payload.json,
        stepResultsLoading: false,
        selectedStepResult: null,
      };
    }
    case SET_STEP_RESULTS_SUCCESS: {
      return {
        ...state,
        stepResultsError: false,
        stepResultsLoading: false,
        selectedStepResult: payload,
      };
    }
    case SET_FLOW_ACTIVITY_FILTERS: {
      return {
        ...state,
        filters: getFilterDefaults(payload.filters),
      };
    }
    case SET_DATE_TYPE_FILTER: {
      return {
        ...state,
        selectedDateTypeFilter: payload,
      };
    }
    case FLOW_ACTIVITY_SET_SELECTED_REQUEST: {
      return {
        ...state,
        selectedRequest: payload,
      };
    }
    case FLOW_ACTIVITY_SET_SELECTED_STEP_ID: {
      return {
        ...state,
        selectedStepId: payload,
      };
    }
    case flowDesignerActions.MARK_INTEGRATION_DELETED: {
      const { blockIds } = payload;
      return {
        ...state,
        filters: getFilterDefaults({
          ...state.filters,
          flowTrigger: difference(state.filters.flowTrigger, blockIds ?? []),
        }),
      };
    }
    default:
      return state;
  }
}
